import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Angular2Multiselects} from '../../../../../util/multiselect';
import {FormFieldOptionItem} from "../../../../../util/form/form-utils";
import {MultiselectOptionItem} from "../../../../../util/core-utils";
import {StockSelectorDialogData} from "../../../../stock/stock-selector-dialog/stock-selector-dialog.component";

@Component({
    selector: 'app-form-record-field-copy-dialog',
    templateUrl: './form-record-field-copy-dialog.component.html',
    styleUrls: ['./form-record-field-copy-dialog.component.scss']
})
export class FormRecordFieldCopyDialogComponent implements OnInit {

    selectedField: FormFieldOptionItem[] = [];

    dropdownSettings: Angular2Multiselects.Settings;

    constructor(public dialogRef: MatDialogRef<FormRecordFieldCopyDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: FormRecordFieldCopyDialogData) {
        this.initDropdownSettings();
    }

    ngOnInit() {
    }

    initDropdownSettings() {
        this.dropdownSettings = new Angular2Multiselects.SettingsBuilder()
            .singleSelection(true)
            .enableSearchFilter(true)
            .enableCheckAll(false)
            .remoteSearch(false)
            .build();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    get isItemSelected(): boolean {
        return this.selectedField.length > 0;
    }

    get selectedItem(): FormFieldOptionItem | undefined {
        return this.selectedField.length > 0 ? this.selectedField[0] : undefined;
    }

    static openDialog(    dialog: MatDialog,
                          data: FormRecordFieldCopyDialogData,
                          resultCallback: (result?: FormFieldOptionItem) => void
    ) {
        const dialogRef = dialog.open(FormRecordFieldCopyDialogComponent, {
            data: data,
            width: '60vw',
            panelClass: 'custom-dialog-container',
            closeOnNavigation: true,
        });
        dialogRef.afterClosed().subscribe((result?: FormFieldOptionItem) => {
            resultCallback(result);
        });
    }
}

export interface FormRecordFieldCopyDialogData {
    selectableFields: FormFieldOptionItem[];
}

